module.exports = __webpack_public_path__ + "img/Gold.07541648.png";